
<template>
<section class="wrapper charity-detail">
  <div class="towing-detail-header">
    <div class="towing-status">
      <h1> {{ data.company_name }} </h1>
      <chc-input id="towingCompany-status"
                 v-model="data.status"
                 label="Status"
                 class="top-status"
                 format="combo"
                 :autoCompleteValues="$store.state.constants.towing_companies.towing_company_status"></chc-input>
    </div>
    <dl>
      <dt class="data-label">City, State</dt>
      <dd class="data-content"> {{ data.address_city }}, {{ data.address_state }}</dd>
    </dl>
  </div>
  <chc-tab-control>
    <chc-tab-pane label="Towing Company Information">
      <towingCompany-information
        :towingCompanyId="towingCompanyId"
        :data="data">
      </towingCompany-information>
    </chc-tab-pane>
    <chc-tab-pane label="Payments">
      <towing-proceeds :towingid="towingCompanyId"></towing-proceeds>
    </chc-tab-pane>
  </chc-tab-control>
</section>
</template>

<script>
import TowingCompanyInformation from '@/components/TowingCompany/TowingCompanyInformation'
import TowingProceeds from '@/components/TowingCompany/TowingProceeds'
import store from '@/store'

export default {
  name: 'TowingCompany',
  data () {
    return {
      data: {}
    }
  },
  props: ['towingCompanyId'],
  beforeRouteEnter (to, from, next) {
    let towingCompanyData = null
    Promise.all([
      store.dispatch('syncConstants'),
      store.dispatch('syncSummary'),
      store.functions.towingCompanies.getTowingCompany(to.params.towingCompanyId, (response) => { towingCompanyData = response.data })
    ]).then(() => {
      next(vm => vm.setData(towingCompanyData))
    })
  },
  methods: {
    setData (data) {
      this.data = data
    }
  },
  computed: {
  },
  components: {
    TowingCompanyInformation,
    TowingProceeds
  }
}
</script>

<style lang="scss" scoped>
/* TOWING DETAILS */
.towing-detail-header {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 2rem;
  .towing-status {
    margin-right: 2rem;
    width: 300px;
  }
  h1 {
    margin: 0 0 1rem 0;
    text-transform: none;
  }
  dl {
    margin: 0 3rem 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TowingCompany/TowingCompany.vue